import dayjs from 'dayjs';

export const usDateFormat = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const usDateWithDayOfWeekFormat = (dateString: string): string => {
  if (!dateString) return '';

  const date = dayjs(dateString);
  const dayOfWeek = date.format('ddd'); // Tue, Wed, Thu 등
  const month = date.format('MMM'); // Jan, Feb, Mar 등
  const day = date.format('D'); // 1, 2, 3 등

  return `${dayOfWeek}, ${month} ${day}`;
};
